import { BellButton } from "@/modules/common/widgets/notification-bell/ui/bell-button";
import Popover from "@/shared/data-display/popover";
import Badge from "@/shared/data-display/badge";
import { usePalette } from "@/shared/theme";
import { useNotificationNumberSubscription } from "@/modules/common/widgets/notification-bell/model/use-notification-number-subscription";
import { useUncompletedTasksNumber } from "@/modules/common/widgets/notification-bell/model/use-uncompleted-tasks-number";
import { usePopoverOpenClose } from "@/modules/common/widgets/notification-bell/model/use-popover-open-close";

import { NotificationBellContent } from "@/modules/common/widgets/notification-bell/notification-bell-content";

export function NotificationBell() {
  const palette = usePalette();

  const primaryColor = palette.primary[5];

  const { unreadMessageNumber } = useNotificationNumberSubscription();
  const { uncompletedTasksNumber } = useUncompletedTasksNumber();
  const allNumber = unreadMessageNumber + uncompletedTasksNumber;

  const { setIsOpen, isOpen, key } = usePopoverOpenClose();

  return (
    <Popover
      open={isOpen}
      onOpenChange={setIsOpen}
      trigger={"click"}
      classNames={{
        body: "!p-0",
      }}
      rootClassName={"[&_.ant-popover-inner-content]:!max-h-[85vh]"}
      content={
        <NotificationBellContent
          key={key}
          primaryColor={primaryColor}
          allNumber={allNumber}
          unreadMessageNumber={unreadMessageNumber}
          uncompletedTasksNumber={uncompletedTasksNumber}
        />
      }
    >
      <Badge count={allNumber} color={primaryColor}>
        <BellButton />
      </Badge>
    </Popover>
  );
}
